<div class="input-container no-border">
  <div class="row">
    <div class="column income-label">
      <mat-checkbox [(ngModel)]="checked">
        {{ fieldsLabel | translate }}
      </mat-checkbox>
    </div>
    @if (checked) {
      <div class="column">
        <div class="row">
          <div class="column">
            <app-form-input
              [label]="amountLabel"
              [placeholder]="placeholder"
              [(model)]="amount"
            ></app-form-input>
          </div>
          <div class="column">
            <app-form-input
              [label]="resultLabel"
              [placeholder]="placeholder"
              [(model)]="calculated"
            ></app-form-input>
          </div>
        </div>
      </div>
    }
  </div>
</div>
